export type SerializedClientError = {
    response: { errors?: unknown; status: number }
    request: { query: string | string[]; variables?: unknown }
}

export function isSerializedClientError(value: unknown): value is SerializedClientError {
    if (typeof value !== "object" || value === null) return false
    const record = value as Record<string, unknown>

    return typeof record.response === "object" && typeof record.request === "object"
}
